export function getPlatform() {
    const ua = navigator.userAgent
    const isIOS = /iPad|iPhone|iPod/.test(ua)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    const isAndroid = /Android/i.test(ua)
    if (isIOS) return 'ios'
    if (isAndroid) return 'android'
    return 'other'
  }

// Best-effort OS version parsed from the user agent. iOS reports it as
// "OS 18_5"; Android as "Android 14". Returns '' when it can't be determined.
export function getOsVersion() {
    const ua = navigator.userAgent
    const platform = getPlatform()

    if (platform === 'ios') {
        const m = ua.match(/OS (\d+)[._](\d+)(?:[._](\d+))?/)
        if (m) return `${m[1]}.${m[2]}${m[3] ? '.' + m[3] : ''}`
        return ''
    }

    if (platform === 'android') {
        const m = ua.match(/Android (\d+(?:\.\d+)*)/)
        if (m) return m[1]
        return ''
    }

    return ''
}